import { z } from 'zod';

import { UncefactUnitSchema } from '@vestigas/utils';

export const zodAddUnitMappingSchema = z.object({
  issuerId: z.uuid().nullable(),
  unitIdentifier: z.string().trim().min(1),
  uncefactUnit: UncefactUnitSchema,
});
